import React, { useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import "../styles/ViewCertificate.css";
import { certificateList } from "../data/DataCertificate.jsx";
import ScrollToTop from "../components/ScrollToTop.jsx";
import MyPdfFullViewer from "../components/MyPdfFullViewer.jsx";
import { useNavigate } from "react-router-dom";

function ViewCertificate() {
  const navigate = useNavigate();
  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    const expiryTimeCertificate = parseInt(localStorage.getItem("expiryTimeCertificate"), 10);

    if (!isLoggedIn) {
      if (!expiryTimeCertificate || Date.now() > expiryTimeCertificate) {
        // Hapus token dan waktu kedaluwarsa jika tidak valid
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("expiryTimeCertificate");
        navigate("/"); // Redirect ke login
        return;
      }
    }
  }, [navigate]);

  const { id } = useParams();
  const data = certificateList.find((item) => item.id === id);
  if (data == undefined) {
    return <Navigate to="/page-not-found" />;
  }

  return (
    <>
      <section id="detail-portfolio" style={{ backgroundColor: "black", padding: 0, margin: 0 }} className="row justify-content-center">
        <div className="wrapper" style={{ padding: 0 }}>
          <MyPdfFullViewer pdfFile={data.pdf} />
        </div>
      </section>
      <ScrollToTop />
    </>
  );
}

export default ViewCertificate;
